import React from 'react'

const IndustryPartnershipData = [
  {
    heading: 'Advisory Boards',
    para: 'Industry experts provide guidance and feedback on curriculum development, ensuring alignment with industry needs.',
    cls: 'span-4 tone-brand',
  },
  {
    heading: 'Mentorship Programs',
    para: 'Students connect with industry professionals who provide guidance, support, and career advice.',
    cls: '',
  },
  {
    heading: 'Industry Visits',
    para: 'Excursions to industry sites provide students with first-hand exposure to real-world applications and industry practices.',
    cls: '',
  },
  {
    heading: 'Guest Speakers',
    para: 'Industry leaders share their expertise and insights, providing students with valuable perspectives and career inspiration.',
    cls: 'span-4 tone-soft',
  },
]

const IndustryPartnerships = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Partnerships</span>
      <h2 className='home_heading'>Industry partnerships</h2>
      <p className='home_lead'>We foster strong partnerships with leading industries so our programs stay aligned with current trends, emerging technologies, and real-world challenges, while giving students mentorship, exposure, and networking connections.</p>

      <div className='bento'>
        {IndustryPartnershipData.map(({ heading, para, cls }, index) => (
          <div className={`bento_card ${cls}`} key={index}>
            <span className='bento_num'>0{index + 1}</span>
            <h3 className='bento_title'>{heading}</h3>
            <p className='bento_para'>{para}</p>
          </div>
        ))}
      </div>
    </section>
  )
}

export default IndustryPartnerships
